import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axiosConfig';

// Acciones asíncronas
export const fetchExpenses = createAsyncThunk(
    'expenses/fetchExpenses',
    async (eventId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/expenses/${eventId}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || error.message);
        }
    }
);

export const addExpense = createAsyncThunk(
    'expenses/addExpense',
    async (expenseData, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/expenses', expenseData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || error.message);
        }
    }
);

// Puedes agregar más acciones para eliminar gastos

const expenseSlice = createSlice({
    name: 'expenses',
    initialState: {
        expenses: [],
        loading: false,
        error: null,
    },
    reducers: {
        // Reducers síncronos si los necesitas
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchExpenses.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchExpenses.fulfilled, (state, action) => {
                state.expenses = action.payload;
                state.loading = false;
            })
            .addCase(fetchExpenses.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(addExpense.fulfilled, (state, action) => {
                state.expenses.push(action.payload);
            });
        // Agrega casos para otras acciones si es necesario
    },
});

export default expenseSlice.reducer;
